var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSharing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m256 0c-141.58 0-256 114.39-256 256 0 141.58 114.39 256 256 256 141.58 0 256-114.39 256-256 0-141.58-114.39-256-256-256zm-45 256c0 5.65-.8 11.12-2.27 16.31l79.68 46.48c10.88-10.98 25.95-17.79 42.59-17.79 33.08 0 60 26.92 60 60s-26.92 60-60 60-60-26.92-60-60c0-5.65.8-11.12 2.27-16.31l-79.68-46.48c-10.88 10.98-25.95 17.79-42.59 17.79-33.08 0-60-26.92-60-60s26.92-60 60-60c16.64 0 31.71 6.81 42.59 17.79l79.68-46.48c-1.47-5.19-2.27-10.66-2.27-16.31 0-33.08 26.92-60 60-60s60 26.92 60 60-26.92 60-60 60c-16.64 0-31.71-6.81-42.59-17.79l-79.68 46.48c1.47 5.19 2.27 10.66 2.27 16.31z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharing);
export default __webpack_public_path__ + "static/media/sharing.a62b04d63074868b778919dbf7974c75.svg";
export { ForwardRef as ReactComponent };